const zh = {
  translation: {
    "Sign in credentials": "登录凭据",
    "Sign in": "登入",
    "Add Category": "添加类别",
    Title: "标题",
    Description: "描述",
    Add: "加",
    Remove: "去掉",
    "Add/Remove": "添加/删除",
    Success: "成功",
    Danger: "危险",
    Categories: "分类",
    Image: "图片",
    Header: "头",
    Loading: "载入中",
    Error: "错误",
    Edit: "编辑",
    Delete: "删除",
    "Edit Category": "编辑类别",
    Save: "保存",
    "OrderID prefix": "订单ID前缀",
    Order: "订购",
    Email: "电子邮件",
    Password: "密码",
    Enable: "启用",
    Disable: "禁用",
    "Enable/Disable": "启用/禁用",
    Saving: "保存",
    Paypal: "贝宝",
    "Client ID": "客户ID",
    "Client Secret": "客户秘密",
    Sandbox: "砂箱",
    "Publishable Key": "可发布的密钥",
    "Secret Key": "密钥",
    "Delivery Charges": "送货费",
    Price: "价钱",
    "Add Food": "添加食物",
    Category: "类别",
    Select: "选择",
    Variations: "变化",
    Type: "类型",
    "Food Image": "食物形象",
    Foods: "食品",
    "Edit Food": "编辑食物",
    OrderID: "订单ID",
    Orders: "命令",
    Name: "名称",
    Items: "项目",
    Payment: "付款",
    Status: "状态",
    Review: "评论",
    "Mark as": "标记为",
    Users: "用户",
    Phone: "电话",
    Address: "地址",
    "2019-20": "2019-20",
    "About Us": "关于我们",
    Blog: "博客",
    Welcome: "欢迎",
    Logout: "登出",
    Dashboard: "仪表板",
    Configuration: "组态",
    Login: "登录",
    Food: "餐饮",
    "Character limit of max length 50": "最大长度50的字符限制",
    "Character limit of max length 15": "最大长度15的字符限制",
    "Character limit of max length 60": "最大长度60的字符限制",
    "Character limit of max length 20": "最大长度20的字符限制",
    "Character limit of max length 140": "最大长度的字符限制140",
    Currency: "货币",
    "Currency Code": "货币代码",
    "Currency Symbol": "货币符号",
    Notifications: "通知",
    purchaseText: "购买产品后将提供删除功能",
    code: "代码",
    discount: "折扣 %",
    actions: "操作",
    totalOrders: "总订单数",
    totalUsers: "总用户数",
    totalSales: "总销售额",
    averageTotal: "平均评分/总评分",
    filterGraph: "筛选图表",
    startingDate: "开始日期",
    submit: "提交",
    overview: "概览",
    performance: "表现",
    endingDate: "结束日期",
    salesValue: "销售价值",
    salesAmount: "销售金额",
    orderCount: "订单数量",
    categoryUpdated: "类别更新成功",
    categoryAdded: "类别成功添加",
    actionFailed: "操作失败，请重试",
    egBreakfast: "例如，早餐",
    egAllHappiness: "例如，所有的幸福都取决于悠闲的早餐。",
    newAddon: '新附加组件',
    uniqueTitle: '标题必须唯一',
    egSmall: '例如小',
    foodUpdated: "食品成功更新",
    foodAdded: "食品成功添加",
    Addons: "附加组件",
    Options: "选项",
    selectOneOption: "至少选择一个选项",
    new: "新",
    addRemoveAddons: "添加/移除附加组件",
    quantityMinimum: "最小数量",
    quantityMinText: "必须小于或等于最大值",
    quantityMaximum: "最大数量",
    quantityMaxText: "必须大于或等于最大值",
    egPepsi: "例如：百事可乐",
    egOptional: "例如：可选项",
    option: "选项",
    mustBeANumber: "必须是数字",
    egTextOption: "例如：90.25",
    saved: "已保存",
    errorOccured: "保存时发生错误，请重试",
    discounted: "打折",
    eg99: "例如 9.99",
    eg9: "例如 9",
    filterByOrderId: "按订单编号筛选",
    datetime: "日期和时间",
    stock: "库存",
    Ratings: "评级",
    Riders: "骑手",
    addRider: "添加骑手",
    username: "用户名",
    available: "可用",
    riderUpdatedText: "骑手更新成功",
    riderAddedText: "成功添加骑手",
    editRider: "编辑骑手",
    Option: "选项",
    minimum: "最小",
    maximum: "最大",
    Coupons: "优惠券",
    couponUpdatedText: "优惠券已更新",
    couponAddedText: "已添加优惠券",
    actionFailedError: "操作失败。请重试",
    editCoupon: "编辑优惠券",
    addCoupon: "添加优惠券",
    couponCode: "优惠券代码",
    discountPercent: "折扣百分比",
    btw1And100: "介于1和100之间",
    enableDisable: "启用/禁用",
    egSales: "例如：SALE50",
    body: '正文',
    egHello: "例如，你好",
    send: "发送",
    ReasonIfRejected: '拒绝原因',
    Accepted: '已接受',
    Accept: '接受',
    Cancelled: '已取消',
    Cancel: '取消',
    Assign: '分配',
    ShowHide: '显示/隐藏',
    PaymentMethod: '支付方式',
    PaidAmount: '已支付金额',
    AvailableRiders: '可用骑手',
    Rider: '骑手',
    AssignedTo: '分配给',
    SelectStatus: '选择状态',
    OrderStatus: '订单状态',
    CurrentStatus: '当前状态',
    PaymentStatus: '支付状态',
    Customer: '客户',
    OrderDetails: '订单详情',
    Charges: '费用',
    DeliveryCharges: '配送费用',
    Subtotal: '小计',
    Total: '总计',
    Admin: '管理员',
    Stripe: 'Stripe',
    PHRiderName: '张三',
    PHUserName: 'ZhangSan1122',
  },
};
export default zh;
